<template>
  <div class="eyeDiagnosis" @click="icdShow=false">
      <h3>眼部诊断</h3>
      <ul class="nr">
          <li style="text-align: left;display: flex;"><h4 style="margin-right: 5px;">检查结果</h4><span>正常</span></li>
          <li v-if="postData.S_OP_Json.CheckResult_yanweiByEyeCheck">眼位</li>
          <li v-if="postData.S_OP_Json.CheckResult_CampaignOD">眼球运动</li>
          <li v-if="postData.S_OP_Json.CheckResult_IPOD">眼压</li>
          <li  v-if="postData.S_OP_Json.CheckResult_OcularAxisOD">眼轴</li>
          <li v-if="postData.S_OP_Json.CheckResult_SLOD">基础检查</li>
      </ul>
      <ul class="nr ys" style="text-align: left;">
          <li>OD<el-checkbox style="margin-left: 5px;" v-model="jlzc"></el-checkbox></li>
          <li v-if="postData.S_OP_Json.CheckResult_yanweiByEyeCheck">{{postData.S_OP_Json.CheckResult_yanweiByEyeCheck}}</li>
          <li v-if="postData.S_OP_Json.CheckResult_CampaignOD">{{postData.S_OP_Json.CheckResult_CampaignOD}}</li>
          <li v-if="postData.S_OP_Json.CheckResult_IPOD">{{postData.S_OP_Json.CheckResult_IPOD}}mmHg</li>
          <li v-if="postData.S_OP_Json.CheckResult_OcularAxisOD">{{postData.S_OP_Json.CheckResult_OcularAxisOD}}mm</li>
          <li v-if="postData.S_OP_Json.CheckResult_SLOD">{{postData.S_OP_Json.CheckResult_SLOD}}</li>
      </ul>
      <ul class="nr ys">
          <li>OS<el-checkbox style="margin-left: 5px;" v-model="zyzc"></el-checkbox></li>
          <li v-if="postData.S_OP_Json.CheckResult_yanweiByEyeCheck">{{postData.S_OP_Json.CheckResult_yanweiByEyeCheck}}</li>
          <li v-if="postData.S_OP_Json.CheckResult_CampaignOD">{{postData.S_OP_Json.CheckResult_CampaignOS}}</li>
          <li v-if="postData.S_OP_Json.CheckResult_IPOD">{{postData.S_OP_Json.CheckResult_IPOS}}mmHg</li>
          <li v-if="postData.S_OP_Json.CheckResult_OcularAxisOD">{{postData.S_OP_Json.CheckResult_OcularAxisOS}}mm</li>
          <li v-if="postData.S_OP_Json.CheckResult_SLOD">{{postData.S_OP_Json.CheckResult_SLOS}}</li>
      </ul>

    <div class="zhnn">
      <el-button type="primary" style="margin-left: 50px;" size="small" @click="tz(1, 'uf_baseoptometry')">裂隙灯</el-button>
      <el-button type="primary" size="small" @click="tz(2, 'uf_fundusoptometry')">眼底检查</el-button>
    </div>

      <div class="box" style="display: block;">
        <div class="xz" style="height: 130px; width: calc(100% - 40px)">
          <div v-if="0" style="text-align: left; padding-left: 0;padding-bottom: 15px;">
            <span>右眼：</span>
            <span>左眼：</span>
            <span style="padding-left: 30px;">备注：</span>
            <el-input v-model="postData.S_OP_Json.CheckResult_20250918_Diagnosis_Remark" size="small" style="width: 400px; margin-left: 1px;" placeholder="备注" />
          </div>
          <ul class="jlzd">
            <li></li>
            <li>眼表疾病</li>
            <li>屈光不正</li>
            <li>晶体疾病</li>
            <li>青光眼</li>
            <li>玻璃体疾病</li>
            <li>视网膜疾病</li>
            <li>视神经疾病</li>
            <li>眼外肌和眼眶疾病</li>
            <li>眼外伤</li>
            <li>其他疾病</li>
          </ul>
          <ul class="jlzd">
            <li>OD</li>
            <li>
              <el-select
                  :disabled="jlzc"
                  class="srrs"
                  v-model="zddata[0]"
                  filterable
                  allow-create
                  multiple
                  collapse-tags
                  default-first-option
                  placeholder="请选择或输入">
                <el-option
                    v-for="item in ybjb"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </li>
            <li>
              <el-select
                  :disabled="jlzc"
                  class="srrs"
                  v-model="zddata[1]"
                  filterable
                  allow-create
                  multiple
                  collapse-tags
                  default-first-option
                  placeholder="请选择或输入">
                <el-option
                    v-for="item in qgbz"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </li>
            <li>
              <el-select
                  :disabled="jlzc"
                  class="srrs"
                  v-model="zddata[2]"
                  filterable
                  allow-create
                  multiple
                  collapse-tags
                  default-first-option
                  placeholder="请选择或输入">
                <el-option
                    v-for="item in jtjb"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </li>
            <li>
              <el-select
                  :disabled="jlzc"
                  class="srrs"
                  v-model="zddata[3]"
                  filterable
                  allow-create
                  multiple
                  collapse-tags
                  default-first-option
                  placeholder="请选择或输入">
                <el-option
                    v-for="item in qgys"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </li>
            <li>
              <el-select
                  :disabled="jlzc"
                  class="srrs"
                  v-model="zddata[4]"
                  filterable
                  allow-create
                  multiple
                  collapse-tags
                  default-first-option
                  placeholder="请选择或输入">
                <el-option
                    v-for="item in bltjb"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </li>
            <li>
              <el-select
                  :disabled="jlzc"
                  class="srrs"
                  v-model="zddata[5]"
                  filterable
                  allow-create
                  multiple
                  collapse-tags
                  default-first-option
                  placeholder="请选择或输入">
                <el-option
                    v-for="item in swmjb"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </li>
            <li>
              <el-select
                  :disabled="jlzc"
                  class="srrs"
                  v-model="zddata[6]"
                  filterable
                  allow-create
                  multiple
                  collapse-tags
                  default-first-option
                  placeholder="请选择或输入">
                <el-option
                    v-for="item in ssjjb"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </li>
            <li>
              <el-select
                  :disabled="jlzc"
                  class="srrs"
                  v-model="zddata[7]"
                  filterable
                  allow-create
                  multiple
                  collapse-tags
                  default-first-option
                  placeholder="请选择或输入">
                <el-option
                    v-for="item in ywjhykjb"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </li>
            <li>
              <el-select
                  :disabled="jlzc"
                  class="srrs"
                  v-model="zddata[8]"
                  filterable
                  allow-create
                  multiple
                  collapse-tags
                  default-first-option
                  placeholder="请选择或输入">
                <el-option
                    v-for="item in yws"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </li>
            <li>
              <el-select
                  :disabled="jlzc"
                  class="srrs"
                  v-model="zddata[9]"
                  filterable
                  allow-create
                  multiple
                  collapse-tags
                  default-first-option
                  placeholder="请选择或输入">
                <el-option
                    v-for="item in qtjb"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </li>
          </ul>
          <ul class="jlzd">
            <li>OS</li>
            <li>
              <el-select
                  :disabled="jlzc"
                  class="srrs"
                  v-model="zddataos[0]"
                  filterable
                  allow-create
                  multiple
                  collapse-tags
                  default-first-option
                  placeholder="请选择或输入">
                <el-option
                    v-for="item in ybjb"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </li>
            <li>
              <el-select
                  :disabled="jlzc"
                  class="srrs"
                  v-model="zddataos[1]"
                  filterable
                  allow-create
                  multiple
                  collapse-tags
                  default-first-option
                  placeholder="请选择或输入">
                <el-option
                    v-for="item in qgbz"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </li>
            <li>
              <el-select
                  :disabled="jlzc"
                  class="srrs"
                  v-model="zddataos[2]"
                  filterable
                  allow-create
                  multiple
                  collapse-tags
                  default-first-option
                  placeholder="请选择或输入">
                <el-option
                    v-for="item in jtjb"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </li>
            <li>
              <el-select
                  :disabled="jlzc"
                  class="srrs"
                  v-model="zddataos[3]"
                  filterable
                  allow-create
                  multiple
                  collapse-tags
                  default-first-option
                  placeholder="请选择或输入">
                <el-option
                    v-for="item in qgys"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </li>
            <li>
              <el-select
                  :disabled="jlzc"
                  class="srrs"
                  v-model="zddataos[4]"
                  filterable
                  allow-create
                  multiple
                  collapse-tags
                  default-first-option
                  placeholder="请选择或输入">
                <el-option
                    v-for="item in bltjb"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </li>
            <li>
              <el-select
                  :disabled="jlzc"
                  class="srrs"
                  v-model="zddataos[5]"
                  filterable
                  allow-create
                  multiple
                  collapse-tags
                  default-first-option
                  placeholder="请选择或输入">
                <el-option
                    v-for="item in swmjb"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </li>
            <li>
              <el-select
                  :disabled="jlzc"
                  class="srrs"
                  v-model="zddataos[6]"
                  filterable
                  allow-create
                  multiple
                  collapse-tags
                  default-first-option
                  placeholder="请选择或输入">
                <el-option
                    v-for="item in ssjjb"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </li>
            <li>
              <el-select
                  :disabled="jlzc"
                  class="srrs"
                  v-model="zddataos[7]"
                  filterable
                  allow-create
                  multiple
                  collapse-tags
                  default-first-option
                  placeholder="请选择或输入">
                <el-option
                    v-for="item in ywjhykjb"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </li>
            <li>
              <el-select
                  :disabled="jlzc"
                  class="srrs"
                  v-model="zddataos[8]"
                  filterable
                  allow-create
                  multiple
                  collapse-tags
                  default-first-option
                  placeholder="请选择或输入">
                <el-option
                    v-for="item in yws"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </li>
            <li>
              <el-select
                  :disabled="jlzc"
                  class="srrs"
                  v-model="zddataos[9]"
                  filterable
                  allow-create
                  multiple
                  collapse-tags
                  default-first-option
                  placeholder="请选择或输入">
                <el-option
                    v-for="item in qtjb"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </li>
          </ul>
        </div>
        <div class="icd">
          <div class="sou">
            <div style="display: flex; margin-right: 10px;width: 70%;">
              <h4 style="text-align: left;padding-left: 13px;">诊断结论</h4>
              <div style="text-align: left;">
                <p style="padding-bottom: 5px;"><span style="font-weight: 500;">右眼：</span>{{zdod}}</p>
                <p><span style="font-weight: 500;">左眼：</span>{{zdos}}</p>
              </div>
            </div>
            <p>ICD编码:</p>
            <el-input class="srk" v-model="ICDCODE" placeholder="请输入内容"></el-input>
            <el-popover
                placement="bottom"
                width="300"
                trigger="manual"
                v-model="icdShow">
              <ul class="icdlistss">
                <li v-for="item in icdgetList" @click="addicd(item)">{{item.ICDCode}}:{{item.ICDName}}</li>
              </ul>
              <i slot="reference" @click="geticd" class="el-icon-search"></i>
            </el-popover>
          </div>
          <ul class="icd-nr">
            <li v-for="(item, idx) in icdlist">
              <el-tooltip placement="top" effect="light">
                <div slot="content"><el-button size="small" @click="deleicd(idx)" type="danger">删除</el-button></div>
                <p class="icdnrs">{{idx+1}}. {{item}}</p>
              </el-tooltip>
            </li>
          </ul>
        </div>
      </div>


      <div class="box">
          <h4 style="padding-left: 15px;text-align: left;width: 56px">医嘱</h4>
          <div class="xz yz">
              <el-input
                      style=""
                      type="textarea"
                      :rows="1"
                      placeholder="请输入内容"
                      v-model="postData.S_OP_Json.CheckResult_Comment">
              </el-input>
          </div>
      </div>

      <div class="hx" style="height: 5px"></div>

      <div class="box jycl" style="padding-top: 7px;padding-bottom: 7px;align-items: center;">
          <h4 style="text-align: left;width: 60px;">处置建议</h4>
          <div class="xz h2" style="width: calc(100% - 125px); padding-top: 5px;padding-bottom: 5px; height: 30px !important;text-align: left;">
            <el-checkbox-group v-model="checkList" class="dx">
<!--                  <el-checkbox class="xxbos" :label="0">验光配镜</el-checkbox>-->
<!--                  <el-checkbox class="xxbos" :label="1">进一步检查</el-checkbox>-->
                  <el-checkbox class="xxbos" :label="2">定期复诊</el-checkbox>
                  <el-date-picker
                      v-if="checkList.indexOf(2) > -1"
                      style="margin: 0 15px;"
                      size="mini"
                      v-model="postData.S_OP_Json.CZFARecheckTime"
                      type="datetime"
                      placeholder="复查时间">
                  </el-date-picker>
<!--                  <el-checkbox class="xxbos" :label="3">转诊</el-checkbox>-->
<!--                  <el-checkbox class="xxbos" :label="5">药物治疗</el-checkbox>-->
<!--                  <el-checkbox class="xxbos" :label="4">门诊治疗</el-checkbox>-->
<!--                 <el-checkbox class="xxbos" :label="6">住院治疗</el-checkbox>-->
                  <el-select
                    v-if="isshowmzzl && 0"
                    class="srr"
                    v-model="postData.S_OP_Json.CheckResult_DealSuggestion_Des"
                    @focus="xzIdx = 1"
                    filterable
                    allow-create
                    collapse-tags
                    default-first-option
                    placeholder="请选择或输入">
                    <el-option
                      v-for="item in zlsf"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-button class="bnt" type="info"  @click="$router.push({path: '/addZz'})" size="mini">转诊</el-button>
<!--                 <el-dropdown trigger="click" v-if="0" @command="sfxmFn">-->
<!--                  <el-button class="bnt" type="info" size="medium">收费项目</el-button>-->
<!--                  <el-dropdown-menu slot="dropdown">-->
<!--                    <el-dropdown-item command="operation">手术收费</el-dropdown-item>-->
<!--                    <el-dropdown-item command="labtest">化验收费</el-dropdown-item>-->
<!--                    <el-dropdown-item command="treatment">治疗收费</el-dropdown-item>-->
<!--                    <el-dropdown-item command="exam">检查收费</el-dropdown-item>-->
<!--                  </el-dropdown-menu>-->
<!--                </el-dropdown>-->
<!--                 <el-dropdown trigger="click" @command="sqdFn">-->
<!--                  <el-button class="bnt" type="info" size="medium">申请单</el-button>-->
<!--                  <el-dropdown-menu slot="dropdown">-->
<!--                    <el-dropdown-item command="1">手术申请单</el-dropdown-item>-->
<!--                    <el-dropdown-item command="2">化验申请单</el-dropdown-item>-->
<!--                    <el-dropdown-item command="3">检查申请单</el-dropdown-item>-->
<!--                    <el-dropdown-item command="4">治疗申请单</el-dropdown-item>-->
<!--                  </el-dropdown-menu>-->
<!--                </el-dropdown>-->
<!--                <el-button type="info" class="bnt" size="medium" @click="sqdFn('5')">药品处方</el-button>-->


              </el-checkbox-group>
          </div>
      </div>
      <EXCL ref="excl" :odds="zdod" :osds="zdos"></EXCL>
      <el-button type="primary" @click="saves">保存</el-button>
      <el-button type="primary" @click="ysqm">医生签名</el-button>
      <el-dialog
        title="用药详情"
        :visible.sync="yyxqshow"
        width="60%">
      <ul class="yyxq">
        <li>
          <p>用药周期</p>
          <el-select
              size="small"
              class="srr"
              filterable
              allow-create
              v-model="ypitem.Drug_Days"
          >
            <el-option
                v-for="item in yyts"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </li>
        <li>
          <p>用药方式</p>
          <el-select
              size="small"
              class="srr"
              filterable
              allow-create
              v-model="ypitem.Drug_UseMethod"
          >
            <el-option
                v-for="item in yyfs"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </li>
      </ul>
      <ul class="yyxq">
        <li>
          <p>用药频次</p>
          <el-select
              size="small"
              class="srr"
              filterable
              allow-create
              v-model="ypitem.Drug_CountPerDay"
          >
            <el-option
                v-for="item in cishu"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </li>
        <li>
          <p>用药规律</p>
          <el-select
              size="small"
              class="srr"
              filterable
              allow-create
              v-model="ypitem.Drug_TimeInDay"
          >
            <el-option
                v-for="item in shijian"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </li>
      </ul>
      <ul class="yyxq">
        <li>
          <p>眼别</p>
          <el-select
              size="small"
              class="srr"
              filterable
              allow-create
              v-model="ypitem.LeftOrRight"
          >
            <el-option
                v-for="item in yyyanbie"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </li>
        <li>
          <p>每次用量</p>
          <el-select
              size="small"
              class="srr"
              filterable
              allow-create
              v-model="ypitem.Drug_CountPerTime"
          >
            <el-option
                v-for="item in yyyl"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </li>
      </ul>


      <el-button type="primary" style="margin-top: 20px;" @click.stop="desqd" size="small">确定</el-button>
    </el-dialog>

      <el-dialog
        title="提示"
        :visible.sync="showmsgTxt"
        :close-on-press-escape="false"
        :close-on-click-modal='false'
        :show-close='false'
        width="400px">

        <p style="padding-bottom: 20px;">{{msgText}}</p>
      <el-button type="primary" @click="gocz">确定</el-button>
    </el-dialog>


      <el-dialog
        title=""
        :visible.sync="showif"
        :close-on-press-escape="false"
        :close-on-click-modal='false'
        :show-close='false'
        width="850px">
        <IFTC v-if="showif" :srccs="ifcs"></IFTC>
      <el-button type="primary" @click="showif = false">关闭</el-button>
    </el-dialog>

  </div>
</template>

<script>
    import intraocularTension from "../specialSurvey/intraocularTension";
    import { ybjb, qgbz, jtjb, bltjb, swmjb, ssjjb, ywjhykjb, yws, qtjb, qgys} from "./xzdata"
    import pf from "../../publicFn/baseFn"
    export default {
      name: "eyeDiagnosis",
      data() {
            return {
              showif: false,
              jlzc: false,
              zyzc: false,
              msgText: '',
              showmsgTxt: false,
              showzc: false,
              czjlurl: '',
              checkList: [],
              diagnosis: [],
              textarea2: '',
              input: '',
              postData: {S_OP_Json: {}},
              zlsf: [
                {
                  value: '倒睫拔除',
                  label: '倒睫拔除'
                },
                {
                  value: '泪道冲洗',
                  label: '泪道冲洗'
                },
                {
                  value: '泪道结膜囊',
                  label: '泪道结膜囊'
                },
                {
                  value: '角膜异物剔除',
                  label: '角膜异物剔除'
                },
                {
                  value: '取结膜结石',
                  label: '取结膜结石'
                },
                {
                  value: '眼睑下垂',
                  label: '眼睑下垂'
                },
                {
                  value: ' ',
                  label: ' '
                }
              ],
              zlsfval: '',
              isshowmzzl: false,
              isywzl: false,
              ICDCODE: '',
              icdShow: false,
              icdgetList: [],
              icdlist: [],
              cs: [
                {
                  value: '1次/2小时',
                  label: '1次/2小时'
                },
                {
                  value: '1次/天',
                  label: '1次/天'
                },
                {
                  value: '2次/天',
                  label: '2次/天'
                },
                {
                  value: '3次/天',
                  label: '3次/天'
                },
                {
                  value: '4次/天',
                  label: '4次/天'
                },
                {
                  value: ' ',
                  label: ' '
                }
              ],
              sysj: [
                {
                  value: '睡前',
                  label: '睡前'
                },
                {
                  value: '日间',
                  label: '日间'
                },
                {
                  value: ' ',
                  label: ' '
                }
              ],

              ywzlData: [],
              ywzlgwc: [],
              yplist: [],
              ypalllist: [],
              yyxqshow: false,
              ypdqidx: -1,

              cishu: [
                {
                  value: '1次/2小时',
                  label: '1次/2小时'
                },
                {
                  value: '1次/天',
                  label: '1次/天'
                },
                {
                  value: '2次/天',
                  label: '2次/天'
                },
                {
                  value: '3次/天',
                  label: '3次/天'
                },
                {
                  value: '4次/天',
                  label: '4次/天'
                },
                {
                  value: '',
                  label: ''
                },
              ],
              shijian: [
                {
                  value: '睡前',
                  label: '睡前'
                },
                {
                  value: '日间',
                  label: '日间'
                },
                {
                  value: '',
                  label: ''
                },
              ],
              yyts: [
                {
                  value: '1天',
                  label: '1天'
                },
                {
                  value: '2天',
                  label: '2天'
                },
                {
                  value: '3天',
                  label: '3天'
                },
                {
                  value: '4天',
                  label: '4天'
                },
                {
                  value: '5天',
                  label: '5天'
                },
                {
                  value: '6天',
                  label: '6天'
                },
                {
                  value: '7天',
                  label: '7天'
                },
                {
                  value: '10天',
                  label: '10天'
                },
                {
                  value: '2周',
                  label: '2周'
                },
                {
                  value: '3周',
                  label: '3周'
                },
                {
                  value: '1个月',
                  label: '1个月'
                },
                {
                  value: '3个月',
                  label: '3个月'
                },
                {
                  value: '半年',
                  label: '半年'
                },
                {
                  value: '长期',
                  label: '长期'
                },
                {
                  value: '',
                  label: ''
                }
              ],
              yyfs: [
                {
                  value: '口服',
                  label: '口服'
                },
                {
                  value: '外用冷敷',
                  label: '外用冷敷'
                },
                {
                  value: '外用热敷',
                  label: '外用热敷'
                },
                {
                  value: '滴眼',
                  label: '滴眼'
                },
                {
                  value: '涂抹',
                  label: '涂抹'
                },
                {
                  value: '',
                  label: ''
                }
              ],
              cishuVal: '',
              shijianVal: '',
              yyyl: [
                {
                  value: '一次1滴/片/粒',
                  label: '一次1滴/片/粒'
                },
                {
                  value: '一次2滴/片/粒',
                  label: '一次2滴/片/粒'
                },
                {
                  value: '一次3滴/片/粒',
                  label: '一次3滴/片/粒'
                },
                {
                  value: '',
                  label: ''
                }
              ],
              yyyanbie: [
                {
                  value: 'OU',
                  label: 'OU'
                },
                {
                  value: 'OS',
                  label: 'OS'
                },
                {
                  value: 'OD',
                  label: 'OD'
                },
                {
                  value: '',
                  label: ''
                }
              ],
              ypitem: {},
              ybjb,
              qgbz,
              jtjb,
              bltjb,
              swmjb,
              ssjjb,
              ywjhykjb,
              yws,
              qtjb,
              qgys,
              zddata: [[],[],[],[],[],[],[],[],[],[]],
              zddataos: [[],[],[],[],[],[],[],[],[],[]],
              zdos: '',
              zdod: '',
              ifcs: ''
            }
      },
      watch: {
        postData: {
          handler(n, o) {
            this.$store.commit('expertClinic/upExpertClinicData', n)
          },
          deep: true
        },
        checkList: {
          handler(n) {
            let arr = Array(6).fill(0)
            this.isshowmzzl = Array.from(n).some(item => item == 4)
            this.isywzl = Array.from(n).some(item => item == 5)
            for (let i = 0; i < n.length; i++) {
              arr[n[i]] = 1
            }
            this.postData.S_OP_Json.CheckResult_DealSuggestion = arr.join(',')
          },
          deep: true
        },
        diagnosis: {
          handler(n) {
            let arr = [0,0,0,0,0,0,0,0,0,0]
            for (let i = 0; i < n.length; i++) {
              arr[n[i]] = 1
            }
             this.postData.S_OP_Json.CheckResult_Diagnosis = arr.join(',')
          },
          deep: true
        },
        icdlist: {
          handler(n) {
            if (n) {
              this.postData.S_OP_Json.ICD_EyeCheck = this.icdlist.join(',')
            }
          },
          deep: true
        },
        jlzc: {
          handler(n) {
            if (n) {
              for (let i = 0; i < this.zddata.length; i++) {
                this.zddata[i] = []
              }
              this.zdod = ''
            }
          }
        },
        zyzc: {
          handler(n) {
            if (n) {
              for (let i = 0; i < this.zddataos.length; i++) {
                this.zddataos[i] = []
              }
              this.zdos = ''
            }
          }
        },
        zddata: {
          deep: true,
          handler(n) {
            let str = ''
            for (let i = 0; i < n.length;i++) {
              if (n[i].length) {
                str = str + n[i].join(',') + '；'
              }
            }
            this.zdod = str
          }
        },
        zddataos: {
          deep: true,
          handler(n) {
            let str = ''
            for (let i = 0; i < n.length;i++) {
              if (n[i].length) {
                str = str + n[i].join(',') + '；'
              }
            }
            this.zdos = str
          }
        }
      },
      created() {
        if (!this.$store.state.users.employees) {
          return false
        }
        if (!this.$store.state.users.CsUser) {
          return this.$alert('用户没有登录！请登录', '提示')
              .then(res => {
                this.$router.push({path: '/home/acceptsHome'})
              })
        }

        if (!this.$store.state.physicianVisits.xzConsulting) {
          return this.$alert('请选择或者新建咨询', '提示')
              .then(res => {
                this.$router.push({path: '/home/acceptsHome'})
              })
        }

        // this.getyplb()

        let log = this.$loading({
          text: '加载中...'
        })

        this._api.expertClinic.getExpertClinic()
        .then(res => {
          log.close()
          if (res.status != 5000 && res.status != 1010) {
            this.$store.commit('expertClinic/upIsSave', res.msg)
            if (res.status == 1080) {
              this.showmsgTxt = true
              this.msgText = res.msg
            }
            this.$alert(res.msg, '提示')
            return
          }else {
            this.$store.commit('expertClinic/upIsSave', 'Success')
          }
          if (res.status == 1010) {
            this.$alert(res.msg, '提示')
          }
          if (res.GetResult) {
            res.GetResult.S_OP_Json = this._clJson(res.GetResult.S_OP_Json)
            this.postData = res.GetResult
            let jlzdp = this.postData.S_OP_Json.CheckResult_20250918_Diagnosis_OD
            if (jlzdp) {
              let arrs = jlzdp.split('-')
              for (let i = 0; i < arrs.length; i++) {
                if (arrs[i]) {
                  this.zddata[i] = arrs[i].split(',')
                }
              }
              let str = ''
              for (let i = 0; i <  this.zddata.length;i++) {
                if ( this.zddata[i].length) {
                  str = str +  this.zddata[i].join(',') + '；'
                }
              }
              this.zdod = str
            }

            let jlzdpos = this.postData.S_OP_Json.CheckResult_20250918_Diagnosis_OS
            if (jlzdpos) {
              let arrs2 = jlzdpos.split('-')
              for (let i = 0; i < arrs2.length; i++) {
                if (arrs2[i]) {
                  this.zddataos[i] = arrs2[i].split(',')
                }
              }
              let str = ''
              for (let i = 0; i <  this.zddataos.length;i++) {
                if ( this.zddataos[i].length) {
                  str = str +  this.zddataos[i].join(',') + '；'
                }
              }
              this.zdos = str
            }


            let str = this.postData.S_OP_Json.ICD_EyeCheck
            this.icdlist = str?str.split(','):[]
            this.$store.commit('expertClinic/upisupData', Math.random().toFixed(6).slice(-6))
            this.diagnosis = this.clStr(this.postData.S_OP_Json.CheckResult_Diagnosis)
            //console.log(this.postData.S_OP_Json.CheckResult_DealSuggestion)
            this.checkList = this.clStr(this.postData.S_OP_Json.CheckResult_DealSuggestion)
          }
        })
      },
      methods: {
        sqdFn(e) {
          // this.$router.push({
          //   path: '/sqdList',
          //   query: {
          //     num: e
          //   }
          // })
          this.ifcs = e
          this.showif = true
        },
        sfxmFn(e) {
          this.$router.push({
            path: '/frameWithHome/frameChoose?type='+e,
          })
        },

        clStr(str, num=10) {
            if (!str) return []
            let arr = [], item = str.split(',')
            for (let i = 0; i < item.length; i++) {
              if (Number(item[i])) {
                arr.push(i)
              }
            }
            return arr
        },
        go(type) {
          if (!this.$store.state.users.employees) {
            return this.$alert('员工未登陆，请先登陆','提示')
                .then(res => {
                  this.$router.push({path: '/employeesLanding'})
                })
          }

          if (type=='treatment') {
            this.$router.push({
              path: '/frameWithHome/frameChoose?type=treatment'
            })
            return
          }

          // this.$router.push({
          //   path: '/frameWithHome/frameChoose?type=drug'
          // })

          let arr = this.$store.state.users.user.Company.ListCompanyConfig
          let yg =  this.$store.state.users.employees,
              csID = this.$store.state.users.CsUser.CustomerId,
              chosID = this.$store.state.physicianVisits.xzConsulting,
              uid = this.$store.state.users.user.UserId,
              shopID = this.$store.state.bases.shop.ShopId,
              ERP_com = ''
          ERP_com = arr.filter(item => item.BCKey == 'ERPSource')
          if (ERP_com && ERP_com.length > 0) {
            ERP_com = ERP_com[0].BCValue
          }else {
            return  this.$router.push({
              path: '/frameWithHome/frameChoose?type=drug'
            })
          }
          if (arr && arr.length > 0) {
            let obj = arr.filter(item => item.BCKey == 'ERP_SellURL')
            let url = obj[0].BCValue
            if (!yg.ListERPCode) {
              return this.$alert('您暂无权限！')
            }
            let yscode = yg.ListERPCode[0].ObjectCode?yg.ListERPCode[0].ObjectCode:''
            if(url) {
              url = url.replace('{ERP_com}', ERP_com)
              url =url.replace('{Expert_Code}', yscode)
              url =url.replace('{CustomerId}', csID)
              url =url.replace('{ChooseId}', chosID)
              url =url.replace('{COAddUserId}', uid)
              url =url.replace('{COExpertId}', yg.ExpertId)
              url = url.replace('{COShopId}', shopID)
            }
            window.open(url)
          }
        },
        geticd() {
          if (!this.ICDCODE) {
            return this.$alert('请输入内容', '提示')
          }
          let lig = this.$loading({
            text: '加载中....'
          })
          this._api.expertClinic.getICDCODE(this.ICDCODE)
          .then(res => {
            lig.close()
            //console.log(res.GetListResult)
            this.icdShow = true
            if (res.GetListResult && res.GetListResult.length) {
               this.icdgetList = JSON.parse(JSON.stringify(res.GetListResult))
            }else {
              this.icdgetList = []
            }
          })
        },
        deleicd(idx) {
          this.icdlist.splice(idx, 1)
        },
        addicd(item) {
          let str = item.ICDCode +":"+item.ICDName
          if (!this.icdlist.some(item => item==str)) {
             this.icdlist.push(str)
          }
          this.icdShow = false
        },
        tz(idx, str) {
          this.$router.push({
            path: '/home/examinationEyesHome?idx=' + idx + '&str='+ str
          })
        },


        getyplb () {
          let obj = {
            "SearchCondition" : {
                  "CHPProductSortGroup" : "drug",
                  "CompanyId" : this.$store.state.users.user.Company.CompanyId,
                  "ChooseId" : this.$store.state.physicianVisits.xzConsulting,
                  "bDelete" : 0,
                  "IndexMin" : 1,
                  "IndexMax" : 20,
                  "CHPStatus" : "1"
            },
            "ProductSource" : "",
            "ReturnInfo" : {
                  "ProductRelation" :
                      {
                        "ShopProduct" : 1,
                        "Product" :
                            {
                              "Brand" : 1,
                              "Sort" : 1
                            }
                      },
                  "InspectionOrder" : 1
            },
            "token" : {
              "sToken" : "AC01E3D93B3F108B690095558CEAE3EC",
              "TimeSpan" : "1688113906"
            }
          }
          this._http.post(this._getUrl('getChooseList'), obj)
          .then(res => {
            let item = []
            if (res.GetListResult && res.GetListResult.length) {
              this.ywzlgwc = [...res.GetListResult]
              for (let i = 0; i < res.GetListResult.length; i++) {
                item.push({
                  id: res.GetListResult[i].CHPProductId,
                  name:  res.GetListResult[i].ProductRelation.ProductDetail.ProductName,
                  des: pf.decoding(res.GetListResult[i].CHPPrescriptionData),
                  ChooseProductId: res.GetListResult[i].ChooseProductId,
                  CHPPrice: res.GetListResult[i].ProductRelation.ShopProduct.SPShopPrice,
                  sl: res.GetListResult[i].CHPAmount
                })
              }
            }
            this.ywzlData = [...item]

            // console.log(this.ywzlData)
          })


          this._http.post(this._getUrl('priceSortList'), {
            "SearchCondition" : {
              "ShopId" : this.$store.state.bases.shop.ShopId,
              "PriceEnd" : 0,
              "PSId" : "",
              "IndexMin" : 0,
              "BrandId" : "",
              "IndexMax" : 100,
              "ShopBrandOrder" : 1,
              "PriceStart" : 0,
              "SortKey" : "drug"
            },
            "ReturnInfo" : {
              "ShopProduct" : 1,
              "Product" : {
                "Brand" : 1,
                "Sort" : 0
              }  },
            "token" : {
              "sToken" : "8C29167B0ADF034F582C73D350369D8E",
              "TimeSpan" : "1688355555"
            },
            "SearchString" : ""
          })
              .then(res => {
                // console.log(res)
                let item = []
                if (res.GetRelationListResult && res.GetRelationListResult.length) {
                  this.ypalllist = [...res.GetRelationListResult]
                  for (let i = 0; i < res.GetRelationListResult.length; i++) {
                    let s = ''
                    if (res.GetRelationListResult[i].ShopProduct.SPbNoCountSale == 1) {
                      if(res.GetRelationListResult[i].ShopProduct.SPAmount > 0){
                        s = res.GetRelationListResult[i].ShopProduct.SPAmount
                      } else{
                        s = '无限'
                      }
                    }else {
                      if(res.GetRelationListResult[i].ShopProduct.SPAmount > 0){
                        s = res.GetRelationListResult[i].ShopProduct.SPAmount
                      } else{
                        s = '无库存'
                      }
                    }

                    let q = res.GetRelationListResult[i].ProductDetail.Brand.BrandName
                    item.push({
                      value:  res.GetRelationListResult[i].ProductDetail.AllProduct.ProductId,
                      label: q +'--'+ res.GetRelationListResult[i].ProductDetail.AllProduct.ProductName+ '--' + s
                    })
                  }
                }
                this.yplist = [...item]
              })
        },
        desqd() {
          this.ywzlData[this.ypdqidx].des =  JSON.parse(JSON.stringify(this.ypitem))
          this.yyxqshow = false
        },
        yyxq(obj, idx) {
          this.yyxqshow = true
          this.ypitem = {
            Drug_Days: '',
            Drug_UseMethod: '',
            Drug_CountPerDay: '',
            Drug_TimeInDay: '',
            LeftOrRight: '',
            Drug_CountPerTime: '',
          }

          this.ypdqidx = idx
          // console.log(obj)
          if (obj.des) {
           this.ypitem = JSON.parse(JSON.stringify(obj.des))
          }
        },
        bh(e,idx) {
          // console.log( this.ywzlData[idx])

          for (let i = 0; i < this.ypalllist.length; i++) {
            if (this.ypalllist[i].ProductDetail.AllProduct.ProductId == e) {
              if (!this.ypalllist[i].ShopProduct.SPbNoCountSale) {
                if (this.ypalllist[i].ShopProduct.SPAmount == 0) {
                  this.ywzlData[idx].id = ''
                  return this.$alert('库存不足，请选择其他药品', '提示')
                }
              }
            }
          }

          if (this.ywzlgwc.length) {
            let gwcidx = -1
            for (let i = 0; i < this.ywzlgwc.length; i++) {
              if (e === this.ywzlgwc[i].CHPProductId) {
                gwcidx = i
              }
            }
            if (gwcidx > -1) {
              this.ywzlData[idx].des = pf.decoding(this.ywzlgwc[gwcidx].CHPPrescriptionData)
              this.ywzlData[idx].name = this.ywzlgwc[gwcidx].ProductRelation.ProductDetail.ProductName
              this.ywzlData[idx].ChooseProductId = this.ywzlgwc[gwcidx].ChooseProductId
            }else {
              this.ywzlData[idx].ChooseProductId = ''
            }
          }

          if (!this.ywzlData[idx].ChooseProductId) {
            this.ywzlData[idx].des = ''
            this.ywzlData[idx].name = ''
            this.ywzlData[idx].ChooseProductId = "00000000-0000-0000-0000-000000000000"
          }
        },
        add() {
          this.ywzlData.push({
            des: '',
            name: '',
            ChooseProductId: '00000000-0000-0000-0000-000000000000',
            id: '',
            CHPPrice: ''
          })
        },

        saveywbc() {
          if (!this.ywzlData.length) return;
          let obj = {
            "token":{
              "sToken":"7BA5E18877AE752DF55FC8874D0BF364",
              "TimeSpan":"1688356076"
            },
            lo: []
          }, arr = []
          for (let i = 0; i < this.ywzlData.length; i++) {
            if (this.ywzlData[i].id) {
              let item = {
                ChooseProductId: this.ywzlData[i].ChooseProductId?this.ywzlData[i].ChooseProductId:'00000000-0000-0000-0000-000000000000',
                CHPProductSortGroup: 'drug',
                CHPChooseId: this.$store.state.physicianVisits.xzConsulting,
                CHPPrescriptionData: pf.conversionJson(this.ywzlData[i].des),
                CHPS_OP_ALL_Id: '00000000-0000-0000-0000-000000000000',
                CHPAmount: this.ywzlData[i].sl ? this.ywzlData[i].sl : 1,
                CHPProductId: this.ywzlData[i].id,
                CHPPrice: '',
                CHPRequirements: '',
                CHPProductSource: '',
                CHPExpertId: this.$store.state.users.employees?this.$store.state.users.employees.ExpertId:'00000000-0000-0000-0000-000000000000',
              }
              for (let j = 0; j < this.ypalllist.length; j++) {
                if (this.ywzlData[i].id === this.ypalllist[j].ProductDetail.AllProduct.ProductId) {
                  item.CHPPrice =  this.ypalllist[j].ShopProduct.SPShopPrice
                }
              }
              arr.push(item)
            }
          }
          obj.lo = arr
          this._http.post(this._getUrl('updateChooseList'), obj)
          .then(res => {
            // console.log(res)
          })
        },
        deletes(id, idx) {
          // console.log(id)
          if (id === '00000000-0000-0000-0000-000000000000' || !id) {
            this.ywzlData.splice(idx, 1)
            return
          }
          this._http.post(this._getUrl('deleteProductFromList'), {
            "token" : {    "sToken" : "B2671FDA9B7F5526FD0E64E8561BFC69",    "TimeSpan" : "1688355668"  },  "ChooseProductId" : id
          })
              .then(res => {
                // console.log(res)
                if (res.msg == 'Success') {
                  this.ywzlData.splice(idx, 1)
                }else {
                  this.$alert('删除失败', '提示')
                }
              })
        },

        gocz() {
          this.$router.push({path: '/ifame2', query: {type: 0}})
        },

        ysqm() {
          this._api.expertClinic.ysqm()
              .then(res => {
                if (typeof res === 'object') {
                  if (res.InsertResult) {
                    this.$store.commit('physicianVisits/upIsqm', false)
                    this.$alert('提交签名成功', '提示')
                  }else {
                    this.$alert('提交签名失败', '提示')
                  }
                }
              })
        },
        saves() {
          if (this.$store.state.expertClinic.isSave !== 'Success') {
            return this.$alert(this.$store.state.expertClinic.isSave, '提示')
                .then(res => {
                  this.$router.push({path: '/ifame2', query: {type: 0}})
                })
          }

          let arrs = ''
          for (let i = 0; i < this.zddata.length; i++) {
            if (i == 0) arrs = arrs + this.zddata[i].join(',') + '-'
            if (i == 1) arrs = arrs + this.zddata[i].join(',') + '-'
            if (i == 2) arrs = arrs + this.zddata[i].join(',') + '-'
            if (i == 3) arrs = arrs + this.zddata[i].join(',') + '-'
            if (i == 4) arrs = arrs + this.zddata[i].join(',') + '-'
            if (i == 5) arrs = arrs + this.zddata[i].join(',') + '-'
            if (i == 6) arrs = arrs + this.zddata[i].join(',') + '-'
            if (i == 7) arrs = arrs + this.zddata[i].join(',') + '-'
            if (i == 8) arrs = arrs + this.zddata[i].join(',') + '-'
            if (i == 9) arrs = arrs + this.zddata[i].join(',')
          }

          let arrsr = ''
          for (let i = 0; i < this.zddataos.length; i++) {
            if (i == 0) arrsr = arrsr + this.zddataos[i].join(',') + '-'
            if (i == 1) arrsr = arrsr + this.zddataos[i].join(',') + '-'
            if (i == 2) arrsr = arrsr + this.zddataos[i].join(',') + '-'
            if (i == 3) arrsr = arrsr + this.zddataos[i].join(',') + '-'
            if (i == 4) arrsr = arrsr + this.zddataos[i].join(',') + '-'
            if (i == 5) arrsr = arrsr + this.zddataos[i].join(',') + '-'
            if (i == 6) arrsr = arrsr + this.zddataos[i].join(',') + '-'
            if (i == 7) arrsr = arrsr + this.zddataos[i].join(',') + '-'
            if (i == 8) arrsr = arrsr + this.zddataos[i].join(',') + '-'
            if (i == 9) arrsr = arrsr + this.zddataos[i].join(',')
          }


          let arr = []
          let datas = this.$store.state.expertClinic.expertClinicData.S_OP_Json

          console.log(this.postData.S_OP_Json)

          arr[0] = {
            key: 'CheckResult_Diagnosis',
            value: datas.CheckResult_Diagnosis
          }
          arr[1] = {
            key: 'CheckResult_DealSuggestion',
            value: datas.CheckResult_DealSuggestion
          }
          arr[2] = {
            key: 'CheckResult_Comment',
            value: this.postData.S_OP_Json.CheckResult_Comment
          }
          arr[3] = {
            key: 'CheckResult_CustomConclusion',
            value: datas.CheckResult_CustomConclusion
          }
          arr[4] = {
            key: 'CheckResult_DealSuggestion_Des',
            value: datas.CheckResult_DealSuggestion_Des
          }
          arr[5] = {
            key: 'ICD_EyeCheck',
            value: datas.ICD_EyeCheck
          }
          arr[6] = {
            key: 'CheckResult_20250918_Diagnosis_OD',
            value: arrs
          }
          arr[7] = {
            key: 'CheckResult_20250918_Diagnosis_OS',
            value: arrsr
          }
          arr[8] = {
            key: 'CZFARecheckTime',
            value: datas.CZFARecheckTime
          }


          this.$store.commit('isbc/upZjzs', {key: 'Recomm1', val: true})

          // this.saveywbc()


          this.$refs.excl.save()

          this._api.expertClinic.saveExpertClinic(arr)
        }
      },
      components: {
        EXCL: () => import('./exCl'),
        IFTC: () => import('./IFTC')
      }
    }
</script>

<style scoped lang="scss">
   .eyeDiagnosis {
       width: 95%;
       margin: 0 auto;
     position: relative;
   }
   h3 {padding-top: 5px;}
   .nr {
       display: flex;
       justify-content: start;
       align-items: center;
       li {
           width: 1.5rem;
           text-align: center;
           overflow: hidden;
           white-space: nowrap;
           text-overflow: ellipsis;
           //padding: 0 .2rem;
       }
       li:nth-child(6) {
           width: 4rem;
       }
       padding: 0.2rem 0;
   }
   .ys {
       padding: 0;
       li {
           background: #f6f6f6;
           padding: 5px 0;
       }
       li:nth-child(1) {background: #ffffff;}
   }
   .box {
       display: flex;
       justify-content: start;
       align-items: flex-start;
       padding:.2rem 0;
       h4 {
           width: 60px;
           padding: 0 12px;
       }
       .xz {
           width: 15rem;
           background: #f6f6f6;
           padding: 0.2rem 0;
           padding-left: .2rem;
           //height: 155px;
       }
       .dx {
           display: flex;
           flex-wrap: wrap;
           align-items: center;
           .xxbos {
               padding: .15rem 0;
           }
           .bnt {margin-left: .1rem}
       }
       .yz {
           width: calc(100% - 110px);
           padding: 0;
           background: #ffffff;
       }
       //.h2 {height: 2rem;}
       .bnt {
          max-width: 10em;
       }
       .icd {
         width: calc(100% - 50px);
         background: #f6f6f6;
         padding: 5px 12px;
         //margin-left: .1rem;
         margin-top: 15px;
         overflow-y: auto;
         .sou {
            display: flex;
            align-items: center;
            .srk {
              width: 13vw;
              margin-left: 12px;
              margin-right: .1rem;
            }
            i{font-size: 18px;cursor: pointer;}
          }
         .icd-nr {
           max-height: 110px;
           margin-top: 1vh;
           overflow-y: auto;
           text-align: left;
           li {
             padding: 5px 0;
             .icdnrs {
               width: 3.7rem;
               overflow: hidden;
               text-overflow: ellipsis;
               white-space: nowrap;
               cursor: pointer;
             }
           }
           li:hover{background: #e5e3e3;}
         }
       }
   }
   .hx {
       width: 100%;
       //height: 5px;
       background: #bbbaba;
       margin: .15rem 0;
   }
   .srr {
     width: 140px;
     margin-left: .4rem;
   }
   .jycl {
     padding-bottom: 20px;
     .ywlist {
       display: flex;
       justify-content: start;
       align-items: start;
       width: 100%;
       .ywlist-title {
         //width: ;
         padding-top: .1rem;
         display: flex;
         p {
           width: 4em;
           font-weight: bold;
           font-size: 15px;
           margin-bottom: .1rem;
         }
         ul {
           //padding-top: 25px;
           li {
             display: flex;
             //align-items: flex-start;
             align-items: center;
             padding-bottom: 10px;
             .srr {
               width: 20em;
               margin-right: 20px;
             }
           }
           li:nth-child(1) {
             padding-left: 22px;
             padding-bottom: 5px;
           }
         }
       }
     }
     //ul {
     //  width: 90%;
     //  display: flex;
     //  justify-content: start;
     //  padding-bottom: .1rem;
     //  li:nth-child(1) {width: 45%;}
     //  li:nth-child(2) {width: 15%;}
     //  li:nth-child(3) {width: 15%;}
     //  li:nth-child(4) {width: 10%;}
     //}
   }
   .icdlistss {
     cursor: pointer;
     max-height: 400px;
     overflow-y: auto;
     li {
       padding: 8px 0;
       &:hover{background: #e3e3e3;}
     }
   }
   .yyxq {
     display: flex !important;
     //flex-wrap: ;
     justify-content: center;
     li {
       padding-left: 15px;
       padding-bottom: 10px;
       p {
         padding-bottom: 5px;
       }
     }
   }

   .jlzd {
     display: flex;
     padding-bottom: 5px;
     li {
       width: 1.5rem;
       text-align: center;
       .srrs {width: 99%;}
     }
     li:nth-child(1) {width: 30px;line-height: 40px;}
   }

   .zhnn {
     position: absolute;
     top: 38px;
     right: 30px;
   }
</style>
